jQuery(document).ready(function($) {

    $('#nav-toggle').click(function(){
        $('#primary-menu').toggleClass('visible');
        $(this).toggleClass('active');

    });

    // =================
    // search
    // =================

    $('.site-header .fa-search').click(function(){
       var searchForm = $(this).siblings('.search-form');
       searchForm.submit();
    });

    $('.mobile-search-reveal').click(function(){
        var searchForm = $('.mobile-search');
        var searchVisible = searchForm.hasClass('visible');
        if (searchVisible == true) {
            searchForm.removeClass('visible');
            $(this).removeClass('active');
        } else {
            searchForm.addClass('visible');
            $(this).addClass('active');
        }
    });

    $('body').click(function(e) {
        // console.log(e);
        if ($(e.target).closest('.search-wrapper').length === 0 && $(e.target).closest('#header-search').length === 0 ) {
            $('.search-wrapper').removeClass('visible');
        }
    });
 
});